export default __webpack_public_path__ + "static/media/sideBar.ed63c13f.png";